<template>
  <div>
    <div class="page-header">
      <h4 class="page-title">{{ contentInfo.title }}</h4>
    </div>
    <app-card v-if="isArray">
      <AppDatatable
        :columns="columns"
        :data="data"
        @create="onClickCreate"
        @update="onClickUpdate"
        @delete="onClickDelete"
      ></AppDatatable>
    </app-card>
    <app-card v-else>
      <app-form @submit="saveItem">
        <app-control
          v-for="prop in contentInfo.props"
          :key="prop.name"
          v-model="editItem[prop.name]"
          :rules="prop.rules"
          :name="prop.name"
          :label="prop.title"
          :type="prop.type"
        />
        <slot name="footer" v-if="!isArray">
          <app-button type="submit" t-label="save" class="float-right mr-2" />
        </slot>
      </app-form>
    </app-card>
    <app-modal-form
      ref="editModal"
      id="editModal"
      @submit="saveItem"
      :title="modalTitle"
      @hide="onHide()"
    >
      <app-control
        v-for="prop in contentInfo.props"
        :key="prop.name"
        v-model="editItem[prop.name]"
        :isEdit="true"
        :rules="prop.rules"
        :name="prop.name"
        :label="prop.title"
        :type="prop.type"
      />
    </app-modal-form>
  </div>
</template>
<script>
import AppDatatable from '@/components/AppDatatable.vue'
import config from '../../.pagenify/config'
import ToastService from '@/services/toast.service'
import { getContents, getContent, createContent, updateContent, uploadFile, getFileUrl, deleteContent } from '../firebase'

export default {
  components: { AppDatatable },
  data () {
    return {
      routeName: '',
      contentInfo: {},
      columns: [],
      data: [],
      options: {},
      editItem: {},
      isArray: true,
      uploadPropNames: [],
      modalTitle: ''
    }
  },
  mounted () {
    this.loadData()
  },
  watch: {
    '$route.name': {
      immediate: true,
      handler (routeName) {
        this.routeName = routeName
        this.modalTitle = routeName
        const contents = config.content.filter(x => {
          return x.name === this.routeName
        })
        this.contentInfo = contents[0]
        this.isArray = this.contentInfo.type === 'array'
        const uploadProps = this.contentInfo.props.filter(
          x => x.type === 'image'
        )
        this.uploadPropNames =
          uploadProps.length > 0 ? uploadProps.map(x => x.name) : []
        this.columns = contents[0].props.map(x => {
          const rowInfo = this.contentInfo.props.filter(
            p => p.name === x.name
          )[0]
          const column = {
            field: x.name,
            title: x.title
          }
          if (rowInfo.type === 'image') {
            column.align = 'center'
            column.formatter = value => {
              return `
              <a href="${value}" target="_blank"><img src="${value}" style="width:64px; height:64px" /></a>`
            }
          }
          return column
        })
      }
    }
  },
  methods: {
    async loadData () {
      const hasOrder = this.isArray
      const contents = await getContents(this.routeName, hasOrder)
      this.data = contents
      if (!this.isArray) {
        this.editItem = contents.length > 0 ? contents[0] : {}
      }
    },
    onClickCreate () {
      this.modalTitle = `${this.routeName} create`
      this.$refs.editModal.show()
    },
    async onClickUpdate (item) {
      this.modalTitle = `${this.routeName} update`
      const data = await getContent(item.id, this.routeName)
      this.uploadPropNames.forEach(propName => {
        data[`${propName}_uploaded`] = data[propName]
        data[propName] = null
      })
      this.editItem = data
      this.$refs.editModal.show()
    },
    async onClickDelete (row) {
      await deleteContent(row.id)
      this.loadData()
    },
    onHide () {
      this.editItem = {}
    },
    async saveItem () {
      const contentData = { ...this.editItem }
      if (this.uploadPropNames.length > 0) {
        for (const propName of this.uploadPropNames) {
          const file = this.editItem[propName]
          if (file) {
            const fileNameSplits = file.name.split('.')
            const uniqueId = Math.random()
              .toString(36)
              .substring(5)
            const fileName = `${this.routeName}_${propName}_${uniqueId}.${fileNameSplits[1]}`
            await uploadFile(fileName, file)
            contentData[propName] = getFileUrl(fileName)
            contentData[`${propName}_uploaded`] = getFileUrl(fileName)
          } else {
            contentData[propName] = this.editItem[`${propName}_uploaded`]
          }
        }

        if (contentData.id) {
          await updateContent(contentData.id, this.routeName, contentData)
        } else {
          await createContent(this.routeName, contentData)
        }

        ToastService.success('Successfully saved.')
        this.$refs.editModal.hide()
        this.loadData()
        this.editItem = {}
      } else {
        if (contentData.id) {
          await updateContent(contentData.id, this.routeName, contentData)
        } else {
          await createContent(this.routeName, contentData)
        }
        ToastService.success('Successfully saved.')
        this.$refs.editModal.hide()
        this.loadData()
      }
    }
  }
}
</script>
